/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import fileDownload from 'js-file-download';
import {
  FETCH_ACTION,
  FETCH_DOWNLOAD_BLOB_REQUEST,
  FETCH_DOWNLOAD_BLOB_RESPONSE,
  FETCH_DOWNLOAD_URL_REQUEST,
  FETCH_DOWNLOAD_URL_RESPONSE,
} from '#constants/actionTypes.js';
import { modelsById } from '#selectors/entities/models.js';
import buildDownloadFilename from '#support/utility/string/buildDownloadFilename.js';

const fetchDownloadUrl = endpoint => ({
  [FETCH_ACTION]: {
    types: [FETCH_DOWNLOAD_URL_REQUEST, FETCH_DOWNLOAD_URL_RESPONSE],
    endpoint,
    dataTransform: json => ({ url: json.url }),
  },
});

const fetchDownloadBlob = endpoint => ({
  [FETCH_ACTION]: {
    types: [FETCH_DOWNLOAD_BLOB_REQUEST, FETCH_DOWNLOAD_BLOB_RESPONSE],
    withAuth: false,
    endpoint,
    dataTransform: blob => ({ blob }),
  },
});

export const download = file => (dispatch, getState) => {
  const { path, name, extension } = file;
  const match = path.match(/\/model\/([^/]+)\/download\//);
  const modelId = match ? match[1] : undefined;
  const modelName = (modelId && (modelsById(getState())[modelId] || {}).modelName) || '';
  return dispatch(fetchDownloadUrl(path))
    .then(a => dispatch(fetchDownloadBlob(a.payload.url)))
    .then(a => fileDownload(a.payload.blob, buildDownloadFilename(modelName, name, extension)));
};
